<template>
  <div class="issueBar2">
    <div class="imgbox">
      <img :src="robotConfig.aiIcon" alt="">
    </div>
    <div class="right-content">
      <div class="title">
        {{ title }}
        <div class="more" @click="allIssue">全部问题 <img src="@/assets/rightIcon.svg" alt=""></div>
      </div>
      <div class="container">
        <ul>
          <li 
            v-for="(item, index) in list" :key="index" 
            @click="clickList(item)"
            v-on:touchstart="handleMouseEnter(index)"
            v-on:touchend="handleMouseLeave(index)"
            :class="index === hoverIndex ? 'containerListart' : ''"
          >
            【问题】 {{ item.questionName }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    robotConfig: {
      type: Object,
      default: () => {
        return {}
      }
    },
    title: {
      type: String,
      default: '猜您想问'
    }
  },
  data() {
    return {
      hoverIndex: -1
    }
  },
  methods: {
    handleMouseEnter(index) {
      this.hoverIndex = index
      console.log('移入', index);
    },
    handleMouseLeave(index) {
      this.hoverIndex = -1
      console.log('移出', index);
    },
    allIssue() {
      this.$emit('allIssue');
    },
    clickList(item) {
      this.$emit('clickList', item);
    },
    changeData() {
      this.$emit('changeData');
    },
  }
}
</script>

<style lang="scss">
.issueBar2 {
  display: flex;
  @keyframes fadeInGradient {
    from {
      opacity: 0.5;
      background-image: linear-gradient(to right,  rgba($color: #fff, $alpha: 0.5) 40%, rgba($color: #dcdcdc, $alpha: 0.3) 60%); /* 开始时背景颜色是均一的 */
      // background-image: linear-gradient(to right, #3498db, #3498db); /* 开始时背景颜色是均一的 */
    }
    to {
      // background: rgba($color: #fff, $alpha: 1.0);
      opacity: 1;
      background-image: linear-gradient(to right, rgba($color: #fff, $alpha: 1.0) 40%, rgba($color: #dcdcdc, $alpha: 0.6) 60%); /* 结束时背景是一个渐变 */
      // background-image: linear-gradient(to right, #3498db, #9b59b6); /* 结束时背景是一个渐变 */
    }
  }
  .containerListart {
    // 产品不要了 说太难做 但已经
    // animation: fadeInGradient 1s ease forwards; /* 应用动画，持续时间为2秒 */
    // 做出来了 以产品为准
    background: #F7F7F7;
  }
  .imgbox {
    overflow: hidden;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    text-align: center;
    img {
      object-fit: cover;
      width: 100%;
    }
  }
  .right-content {
    width: calc(100vw - 120px);
    background: #ffffff;
    // margin: 0 0 16px 0;
    border-radius: 10px;
    // padding: 16px 8px;
    // padding: 12px;
    // margin-left: 7px;
    margin-left: 8px;
  }
  .title {
    padding: 0 12px;
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    color: #1A1A1A;
    font-weight: bold;
    // margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .more {
      font-size: 14px;
      float: right;
      color: #008CFF;
      position: relative;
      // top: -2px;
      img{
        width: 16px;
        height: 16px;
        position: relative;
        top: 2px;
      }
    }
  }

  .container {
    // font-size: 12px;
    // padding: 10px;
    padding-bottom: 6px;
    ul {
      li {
        padding: 6px 12px;
        // border-bottom: 1px solid #EFEFF4;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        font-size: 14px;
        color: #1A1A1A;
        line-height: 20px;
        word-wrap: break-word;
        word-break: break-all;
      }
      li:last-child{
        margin-bottom: 0;
      }
    }
  }

  .changeBtn {
    margin-top: 10px;
    text-align: center;

    button {
      background-color: #3296FA;
      outline: none;
      border: none;
      color: #ffffff;
      padding: 8px 15px;
      border-radius: 5px;
    }

    button:active {
      background-color: #70b3f5;
    }
  }
}
</style>
